// @flow
import { RecordingContext } from '../types/audio-recorder';

export const initializeRecordingContext = (): RecordingContext => {
  return {
    audioProcessor: null,
    audioContext: null,
    sessionId: '',
    sources: [],
    streamNames: [],
    streams: [],
    volumeInterval: null,
  };
};
